import { apiRequest } from '@common/api/utils';

function fetchReferralCoupon() {
  const url = '/programs/referrals/fetch_referral_coupon/';
  const data = apiRequest('GET', url);
  return data;
}

function loadReferralData(params = {}) {
  return apiRequest('POST', '/invite-friends/load-referral-data/', params);
}

export default {
  fetchReferralCoupon,
  loadReferralData,
};
